<template>
  <div class="page-wrapper">

    <div class="content" v-if="userInfo">
      <div>姓名：{{userInfo.empName}}</div>
      <div>邮箱：{{userInfo.email}}</div>
      <div>手机号：{{userInfo.phone}}</div>
      <div>所属角色：{{userInfo.roleNames}}</div>
      <div>性别：{{userInfo.sex === 1?'男':'女'}}</div>
      <div>职位：{{userInfo.positionName}}</div>
      <div>所属机构：{{userInfo.organName}}</div>
      <div>备注：{{userInfo.remark}}</div>
    </div>
    <div>
      <Button @click.stop="toUpdatePhone" type="primary">修改手机号</Button>
      <Button @click.stop="toUpdatePassword" type="primary">修改密码</Button>
    </div>
    <update-phone :n="n1" :phone="userInfo.phone" v-if="userInfo"></update-phone>
    <update-pass-word :n="n2" v-if="userInfo"></update-pass-word>
  </div>
</template>

<script>
  import UpdatePhone from './components/UpdatePhone'
  import UpdatePassWord from './components/UpdatePassWord'
  import {getUser} from "../../../api/login";

  export default {
    name: "index",
    components:{
      UpdatePhone,
      UpdatePassWord

    },
    data(){
      return {
        n1:0,
        n2:0,
        userInfo:{"id":21985,"fid":"8a90a36b643abfac0164473af5532ef9","empCode":"60009801","empName":"左勤悦","empSex":null,"empMail":"zuoqy@ziroom.com","empMobile":"13102158253","empValid":0,"postCode":"100041","postName":"前端工程师","departCode":"100380","departName":"FE研发部","cityCode":"110000","isDel":0,"createDate":1530203403000,"lastModifyDate":1530203404000,"createFid":"001","ehrCityCode":"11","centerCode":"100361","center":"设计中心","groupCode":"101964","groupName":"前端后台系统研发组","branceCompanyCode":"101"},

      }
    },
    methods:{
      toUpdatePhone(){
        this.n1++

      },
      toUpdatePassword(){
        this.n2++

      }
    },
    created(){
      getUser().then(res=>{
        res.data && (this.userInfo=res.data)
      }).catch(error=>{
      })

    }

  }
</script>

<style scoped>
  .content{
    width: 70%;
    display: flex;
    flex-wrap: wrap;
    /*margin: 0 auto;*/
  }
  .content div{
    width: 50%;
    flex: none;
    margin-bottom: 16px;


  }

</style>
